import { RolesTagsProps } from './RolesTags.decl';
import { getRoleColor } from './RolesTags.utils';

import { Spacer, Tag, ThemeProvider } from '@aircall/tractor-v2';
import { dashboardThemeV2 } from '@config/theme/theme';
import { ROLE_NAME, ROLE_ORDER } from '@constants/permissions.constants';
import { isDefined } from '@dashboard/library';
import { useTranslation } from 'react-i18next';

export function RolesTags({ roles }: RolesTagsProps) {
  const { t } = useTranslation();

  if (!roles.length) {
    return null;
  }

  const tags = [...roles]
    .sort((roleA, roleB) => {
      const rankA = ROLE_ORDER[roleA.name] || 0;
      const rankB = ROLE_ORDER[roleB.name] || 0;
      return rankA - rankB;
    })
    .map((role) => {
      const { ID, name } = role;
      const color = getRoleColor(name);

      if (!color || !Object.values(ROLE_NAME).includes(name)) {
        return undefined;
      }

      return (
        <Tag key={ID} variant={color} size='small'>
          {t(`permissions.roles.${name}`)}
        </Tag>
      );
    })
    .filter(isDefined);

  if (!tags.length) {
    return null;
  }

  return (
    <ThemeProvider theme={dashboardThemeV2}>
      <Spacer data-test='roles-tags' direction='horizontal' space='xxxs'>
        {tags}
      </Spacer>
    </ThemeProvider>
  );
}
